import { AxiosError } from "axios";
import { useQuery } from '@tanstack/react-query';
import client from "../../services/client";
import { NastavitevDto } from "../../types/Natavitev/NastavitevDtoType";

// GET ALL
const useFetchNastavitevAll = () => {
    return useQuery<NastavitevDto[], AxiosError>(["nastavitve"], async () => {
        try {
            return (await client.get(`nastavitev/allForClient`)).data;
        }
        catch (error) {
            return Promise.reject(error);
        }
    }, { staleTime: Infinity });
};

export default useFetchNastavitevAll;

/*
// GET BY ID
const useFetchPodrocje = (podrocjeId: number) => {
    return useQuery<PodrocjeFormType, AxiosError>(["podrocje", podrocjeId], async () => {
        try {
            return (await client.get(`podrocje/${podrocjeId}`)).data;
        }
        catch (error) {
            return Promise.reject(error);
        }
    });
}

// PUT - UPDATE
const useUpdatePodrocje = () => {
    const { displayFeedback } = useContext(FeedbackContext);
    const nav = useNavigate();
    const queryClient = useQueryClient();
    return useMutation<AxiosResponse, AxiosError, PodrocjeFormType>(async (podrocje) => {
        try {
            return (await client.put(`podrocje/${podrocje.podrocjeId}`, podrocje));
        }
        catch (error) {
            return Promise.reject(error);
        }
    }, {
        onSuccess: () => {
            queryClient.invalidateQueries(["podrocja"]);
            nav(`/sifrant/organizacija`);
            if (displayFeedback)
                displayFeedback("Organizacija je bila uspešno urejena.", Status.SUCCESS)
        },
        onError: (err) => {
            let errMsg = "Pri posodabljanju organizacije je prišlo do napake."
            let apiException = getApiExceptionObjectFromAxiosError(err);
            if (apiException?.Message)
                errMsg = apiException.Message;

            // TODO?: mogoče se lahko tu kaj poenoti za exception handling...
            if (displayFeedback)
                displayFeedback(errMsg, Status.ERROR)
        }
    });
};

// POST
const useAddPodrocje = () => {
    const { displayFeedback } = useContext(FeedbackContext);
    const nav = useNavigate();
    const queryClient = useQueryClient();
    return useMutation<AxiosResponse, AxiosError, PodrocjeFormType>(async (podrocje) => {
        try {
            return (await client.post(`podrocje`, podrocje));
        }
        catch (error) {
            return Promise.reject(error);
        }
    }, {
        onSuccess: () => {
            queryClient.invalidateQueries(["podrocja"]);
            nav("/sifrant/organizacija");
            if (displayFeedback)
                displayFeedback("Organizacija je bila uspešno dodana.", Status.SUCCESS)
        },
        onError: (err) => {
            let errMsg = "Pri ustvarjanju organizacije je prišlo do napake."
            let apiException = getApiExceptionObjectFromAxiosError(err);
            if (apiException?.Message)
                errMsg = apiException.Message;

            // TODO?: mogoče se lahko tu kaj poenoti za exception handling...
            if (displayFeedback)
                displayFeedback(errMsg, Status.ERROR)
        }
    });
};

// ARCHIVE
const useArchivePodrocje = () => {
    const { displayFeedback } = useContext(FeedbackContext);
    const nav = useNavigate();
    const queryClient = useQueryClient();
    return useMutation<AxiosResponse, AxiosError, number>(async (podrocjeId) => {
        try {
            return (await client.put(`podrocje/archive/${podrocjeId}`, null));
        }
        catch (error) {
            return Promise.reject(error);
        }
    }, {
        onSuccess: () => {
            queryClient.invalidateQueries(["podrocja"]);
            nav(`/sifrant/organizacija`);
            if (displayFeedback)
                displayFeedback("Organizacija je bila uspešno arhivirana.", Status.SUCCESS)
        },
        onError: (err) => {
            let errMsg = "Pri arhiviranju organizacije je prišlo do napake."
            let apiException = getApiExceptionObjectFromAxiosError(err);
            if (apiException?.Message)
                errMsg = apiException.Message;

            // TODO?: mogoče se lahko tu kaj poenoti za exception handling...
            if (displayFeedback)
                displayFeedback(errMsg, Status.ERROR)
        }
    });
};

// REACTIVATE
const useReactivatePodrocje = () => {
    const { displayFeedback } = useContext(FeedbackContext);
    const nav = useNavigate();
    const queryClient = useQueryClient();
    return useMutation<AxiosResponse, AxiosError, number>(async (podrocjeId) => {
        try {
            return (await client.put(`podrocje/reactivate/${podrocjeId}`, null));
        }
        catch (error) {
            return Promise.reject(error);
        }
    }, {
        onSuccess: () => {
            queryClient.invalidateQueries(["podrocja"]);
            nav(`/sifrant/organizacija`);
            if (displayFeedback)
                displayFeedback("Organizacija je bila uspešno aktivirana.", Status.SUCCESS)
        },
        onError: (err) => {
            let errMsg = "Pri aktiviranju organizacije je prišlo do napake."
            let apiException = getApiExceptionObjectFromAxiosError(err);
            if (apiException?.Message)
                errMsg = apiException.Message;

            // TODO?: mogoče se lahko tu kaj poenoti za exception handling...
            if (displayFeedback)
                displayFeedback(errMsg, Status.ERROR)
        }
    });
};

// DELETE
const useDeletePodrocje = () => {
    const { displayFeedback } = useContext(FeedbackContext);
    const nav = useNavigate();
    const queryClient = useQueryClient();
    return useMutation<AxiosResponse, AxiosError, number>(async (podrocjeId) => {
        try {
            return (await client.delete(`podrocje/${podrocjeId}`));
        }
        catch (error) {
            return Promise.reject(error);
        }
    }, {
        onSuccess: () => {
            queryClient.invalidateQueries(["podrocja"]);
            nav("/sifrant/organizacija");
            if (displayFeedback)
                displayFeedback("Organizacija je bila uspešno odstranjena.", Status.SUCCESS)
        },
        onError: (err) => {
            let errMsg = "Pri brisanju organizacije je prišlo do napake."
            let apiException = getApiExceptionObjectFromAxiosError(err);
            if (apiException?.Message)
                errMsg = apiException.Message;

            // TODO?: mogoče se lahko tu kaj poenoti za exception handling...
            if (displayFeedback)
                displayFeedback(errMsg, Status.ERROR)
        }
    });
};

export default useFetchPodrocjaAll;
export { useFetchPodrocje, useUpdatePodrocje, useAddPodrocje, useArchivePodrocje, useReactivatePodrocje, useDeletePodrocje };
*/